<template>
    <div class="row gutter-sm q-mb-lg">
        <div class="col-xs-12 col-sm-4" v-if="!loading">
            <points :score="score" :score_statement="user_score_statement" @showStatement="showStatement" :home="true" />
        </div>

        <div class="col-xs-12 col-sm-4" v-if="!loading">
            <statistics :statistics="statistics" :clientModules="clientModules" />
        </div>

        <div class="col-xs-12 col-sm-4" v-if="!loading && showRanking">
            <ranking @seeAll="seeAll()" :ranking_code="ranking_code" />
        </div>

        <div class="col-12" v-if="!loading && showBadges">
            <badges :badges="badges" />
        </div>

        <q-inner-loading :visible="loading">
            <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
        </q-inner-loading>

        <q-modal v-model="show_all_ranking" :content-css="{minWidth: '100vw', minHeight: '100vh'}" v-if="show_all_ranking">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_all_ranking = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('ranking') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <all-ranking :user_firebase_document_ranking_areas="user_firebase_document_ranking_areas" :user_firebase_document="ranking_code" />
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_statement" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_statement = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('points_statement') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <points-statemenet :score_statement="user_score_statement" />
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { db } from 'plugins/vuefire'
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import Points from 'components/profile/Points.vue'
import PointsStatement from 'components/profile/PointsStatement.vue'
import Ranking from 'components/profile/Ranking.vue'
import AllRanking from 'components/profile/AllRanking.vue'
import Badges from 'components/profile/Badges.vue'
import Statistics from 'components/profile/Statistics.vue'

export default {
    props: ['show_report'],

    data() {
        return {
            loading: false,
            score: null,
            user_score_statement: [],
            badges: null,
            statistics: [],
            ranking_code: null,
            show_all_ranking: false,
            user_firebase_document_ranking_areas: [],
            user_firebase_document: '',
            show_statement: false,
            clientModules: {
                has_courses: false,
                has_trails: false,
                has_presential: false,
                has_live_classes: false,
                has_podcasts: false,
                has_webcasts: false
            }
        }
    },

    components: {
        'points': Points,
        'points-statemenet': PointsStatement,
        'ranking': Ranking,
        'all-ranking': AllRanking,
        'badges': Badges,
        'statistics': Statistics,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            profiles: 'registration_lists/profiles',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showRanking() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) {
                if (obj.has_ranking) return obj.has_ranking
            }
            else return false
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

		showBadges() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			return client.has_badges ? client.has_badges : false
		},
    },

    methods: {
        fetchData() {
            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_statistics/`, this.getHeader)
            .then(response => {
                let statistics = {
                    avg_group_trainings_certified: response.data.avg_group_trainings_certified,
                    qty_group_trainings_certified: response.data.qty_group_trainings_certified,
                    qty_group_trainings_published: response.data.qty_group_trainings_published,
                    user_group_training_progress: response.data.user_group_training_progress,
                    qty_trails_certified: response.data.qty_trails_certified,
                    qty_trails_published: response.data.qty_trails_published,
                    user_trails_progress: response.data.user_trails_progress,
                    qty_presential_certified: response.data.qty_presential_certified,
                    qty_presential_published: response.data.qty_presential_published,
                    user_presential_progress: response.data.user_presential_progress,
                    qty_live_classes_certified: response.data.qty_live_classes_certified,
                    qty_live_classes_published: response.data.qty_live_classes_published,
                    user_live_classes_progress: response.data.user_live_classes_progress,
                    qty_webcasts_certified: response.data.qty_webcasts_certified,
                    qty_webcasts_published: response.data.qty_webcasts_published,
                    user_webcasts_progress: response.data.user_webcasts_progress,
                    qty_podcasts_certified: response.data.qty_podcasts_certified,
                    qty_podcasts_published: response.data.qty_podcasts_published,
                    user_podcasts_progress: response.data.user_podcasts_progress
                }

                this.statistics = statistics
                this.ranking_code = response.data.user_firebase_document
                this.score = response.data.user_score.toFixed(2) * 1
                this.user_score_statement = response.data.user_score_statement
                this.badges = response.data.user_badges
                this.user_firebase_document_ranking_areas = response.data.user_firebase_document_ranking_areas
                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        showStatement() {
            this.show_statement = true
        },

        seeAll() {
            this.show_all_ranking = true
        },

        checkClientModules() {
            const client = this.clients.find(obj => obj.id === this.id_user_client_selected)
            if (client) {
                for (const [key, value] of Object.entries(this.clientModules)) {
                    if (client[key] !== undefined) {
                        this.clientModules[key] = client[key]
                    }
                }
            } else return
        },
    },

    watch: {
        show_report: function() {
            if (this.show_report) {
                setTimeout(() =>{
                    this.fetchData()
                }, 300)
            }
        }
    },

    created() {
        if (this.selected_user) this.fetchData()
        this.checkClientModules()
    }
}
</script>

<style>

</style>
